import { Divider } from '@ds';
import { FaCalendarDay, FaGlobe } from 'react-icons/fa';
import { ReleaseNote } from '@/api/apis/release-notes';
import { formatReleaseDate } from './utils';

type ReleaseNoteDetailsProps = {
  release: ReleaseNote | undefined;
};

export const ReleaseNoteDetails = ({ release }: ReleaseNoteDetailsProps) => (
  <main className="w-[900px] bg-white rounded-r-lg p-4">
    <div className="flex items-center gap-12 border-b border-base-90">
      <div className="flex items-center gap-3">
        <FaCalendarDay className="text-base-40" size={24} />
        <div>
          <div className="text-sm text-base-20 mb-1">Release date</div>
          <div className="text-base-5">{release ? formatReleaseDate(release.releaseDate) : ''}</div>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <FaGlobe className="text-base-40" size={24} />
        <div>
          <div className="text-sm text-base-20 mb-1">Version</div>
          <div className="text-base-5">{release?.version}</div>
        </div>
      </div>
    </div>
    <Divider className="my-4" />

    {Array.isArray(release?.highlights) && release?.highlights?.length > 0 && (
      <section className="mb-8">
        <div className="text-l-m bg-base-80 py-2 px-4 mb-2">Release highlights</div>
        <ul className="pl-4 ml-4">
          {release?.highlights.map((highlight) => (
            <li key={highlight} className="list-disc text-m-r text-base-5 marker:mr-2">
              {highlight}
            </li>
          ))}
        </ul>
      </section>
    )}

    {Array.isArray(release?.bugFixes) && release?.bugFixes?.length > 0 && (
      <section className="mb-8">
        <div className="text-l-m bg-base-80 py-2 px-4 mb-2">Some of the bug fixes</div>
        <ul className="pl-4 ml-4">
          {release?.bugFixes.map((fix) => (
            <li key={fix} className="list-disc text-m-r text-base-5 marker:mr-2">
              {fix}
            </li>
          ))}
        </ul>
      </section>
    )}
  </main>
);
